module.exports = __webpack_public_path__ + "static/media/KARAN ACOUSTICS MASTER COLLECTION PHONO B MONO.d89cd86a.png";